<template>
  <div class="folder">
    
    <div class="folder__icon" @click="emitFolderSelection()">
      <svg viewBox="0 0 512 512" class="folder__icon-open" v-if="currentFolder && currentFolder.folder_slug === folder.folder_slug">
        <path d="M469.333,170.667H106.667c-19.781,0-36.667,13.292-41.375,32.427c-0.021,0.073-0.052,0.156-0.073,0.229L2.771,414.177c-0.677,2.302-0.563,4.771,0.333,7C9.646,437.469,25.167,448,42.667,448h362.667c19.104,0,35.719-12.646,40.938-30.948c0.094-0.229,0.177-0.458,0.25-0.698l63.375-189.833c0.208-0.604,0.344-1.229,0.438-1.854C511.448,220.719,512,217,512,213.333C512,189.802,492.865,170.667,469.333,170.667z"/><path d="M9.135,285.396c0.521,0.083,1.031,0.115,1.542,0.115c4.656,0,8.865-3.052,10.219-7.635l23.771-80.271c0.031-0.125,0.063-0.24,0.094-0.365c7.292-28.208,32.74-47.906,61.906-47.906h328.708c3.469,0,6.719-1.688,8.719-4.521c1.99-2.823,2.49-6.448,1.333-9.719c-6.042-17-22.156-28.427-40.094-28.427h-198.25l-39.542-39.542c-2-2-4.708-3.125-7.542-3.125H42.667C19.135,64,0,83.135,0,106.667v168.177C0,280.146,3.896,284.635,9.135,285.396z"/>
      </svg>

      <svg viewBox="0 0 512 512" class="folder__icon-close" v-else>
        <path d="M469.333,85.333H249.75l-39.542-39.542c-2-2-4.708-3.125-7.542-3.125h-160C19.135,42.667,0,61.802,0,85.333v341.333c0,23.531,19.135,42.667,42.667,42.667h426.667c23.531,0,42.667-19.135,42.667-42.667V128C512,104.469,492.865,85.333,469.333,85.333z"/>
      </svg>
    </div>

    <div :class="{'folder__name': true, 'folder__name--active': currentFolder && currentFolder.folder_slug === folder.folder_slug}" @click="emitFolderSelection()">
      <p>{{ folder.folder_title }}</p>
    </div>

    <div class="folder__buttons">

      <button class="folder__button" @click="goToHistory()" title="Folder history"><svg viewBox="0 0 426.667 426.667"><rect x="192" y="192" width="42.667" height="128"/><path d="M213.333,0C95.467,0,0,95.467,0,213.333s95.467,213.333,213.333,213.333S426.667,331.2,426.667,213.333 S331.2,0,213.333,0z M213.333,384c-94.08,0-170.667-76.587-170.667-170.667S119.253,42.667,213.333,42.667 S384,119.253,384,213.333S307.413,384,213.333,384z"/><rect x="192" y="106.667" width="42.667" height="42.667"/></svg></button>

      <button class="folder__button" @click="editFolder()" title="Edit folder"><svg viewBox="0 0 488.471 488.471"><path d="m166.093 240.214h88.205v194.288h-88.205z" transform="matrix(.707 -.707 .707 .707 1.415 9.959)"/><path d="m245.547 105.541-245.547 245.547v137.382h137.382l245.548-245.547z"/></svg></button>

      <button class="folder__button folder__button--delete" @click="deleteFolder()" title="Delete folder"><svg viewBox="0 0 515.556 515.556"><path d="m64.444 451.111c0 35.526 28.902 64.444 64.444 64.444h257.778c35.542 0 64.444-28.918 64.444-64.444v-322.222h-386.666z"/><path d="m322.222 32.222v-32.222h-128.889v32.222h-161.111v64.444h451.111v-64.444z"/></svg></button>

    </div>

  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Swal from 'sweetalert2/dist/sweetalert2.js';
import {
  FOLDER_UPDATE,
  FOLDER_DELETE
} from "@/store/actions.type";

export default {
  name: "Folder",
  props: ['folder'],
  computed: {
    ...mapGetters(["currentFolder"])
  },
  methods: {
    goToHistory() {
      this.$router.push({
        name: 'History',
        params: {
          id: this.folder.folder_id
        }
      });
    },
    editFolder() {
      
      let vm = this;

      Swal.fire({
        title: 'Rename folder',
        input: 'text',
        inputValue: vm.folder.folder_title,
        inputAttributes: {
          autocapitalize: 'off',
        },
        showCancelButton: true,
        confirmButtonText: 'Rename',
        showLoaderOnConfirm: true,
        preConfirm: (folderTitle) => {
          if(folderTitle == '') {
            return Swal.showValidationMessage(
              "Type folder name"
            )
          }

          let folderData = new FormData();
          folderData.set('folder_title', folderTitle);

          let payload = {
            'folder_slug': vm.folder.folder_slug,
            'folderData': folderData
          }

          return vm.$store.dispatch(FOLDER_UPDATE, payload);
        }
      }).then((response) => {
        if(!response.dismiss) {
          Swal.fire(
            'Updated!',
            'Your folder has been updated.',
            'success'
          )
        }
      });

    },
    deleteFolder() {

      let vm = this;

      Swal.fire({
        title: 'Move to trash',
        text: "Are you sure you want to move this item to the trash?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, move it!'
      }).then((result) => {
        if (result.value) {

          this.$store.dispatch(FOLDER_DELETE, vm.folder.folder_slug);

          Swal.fire({
            title: 'Moved to trash!',
            text: 'Your item has been moved to the trash.',
            icon: 'success'
          });
        }
      });

    },
    emitFolderSelection() {
      this.$emit('clicked', this.folder)
    }
  },
  directives: {
    focus: {
      inserted (el) {
        el.focus()
      }
    }
  }
}
</script>

<style lang="scss">

.folder {
  width: 100%;
  border-bottom: 1px solid #f1f1f1;
  padding: rem(4px) 0;
  display: flex;
  align-items: center;

  &__icon {

    svg {
      width: rem(24px);
      height: rem(24px);
      margin-right: rem(16px);
    }

    &:hover {
      cursor: pointer;
    }
  }

  &__icon-open {
    fill: $color-java;
  }

  &__icon-close {
    fill: $color-abbey;
  }

  &__name {
    display: inline-block;
    color: #000;
    font-size: rem(14px);
    line-height: 1;
    transition: color .3s ease;

    &:hover {
      cursor: pointer;
      color: $color-abbey;
    }

    p {
      margin-bottom: 0;
    }
  }

  &__name--active {
    color: $color-java;
  }

  &__buttons {
    margin-left: auto;
  }

  &__button {
    margin: 0;
    padding: 0;
    border: 0;
    background: none;
    margin-left: rem(8px);

    &:focus {
      outline: none;

      svg {
        fill: $color-genoa;
      }
    }

    svg {
      width: rem(16px);
      height: rem(16px);
      fill: $color-genoa;
      transition: fill .3s ease;

      &:hover {
        fill:$color-java;
      }
    }
  }

  &__button--delete {

    svg {
      // fill: #cbcbcb;
      fill: $color-genoa;

      &:hover {
        fill: $color-java;
      }
    }
  }
}

</style>